export default {
  id: null,
  queryParams: undefined,
  defer: false,
  debug: false,
  enabled: true,
};
